import apiInstance from '../../../../backend-api.setup'
import { ApiPathConfig } from '../../../../../config/ApiPathConfig'

const DeleteInfluencerSocialMedia = (userId: string, socialMediaId: string) => {
  return apiInstance.delete(
    ApiPathConfig.INFLUENCER_SOCIAL_MEDIA_BY_ID(userId, socialMediaId),
  )
}

export default DeleteInfluencerSocialMedia
